import './styles.css';
import React, { useState, useEffect } from 'react';
import { useMatch,BrowserRouter as Router, Routes, Route, Link, useLocation,ScrollRestoration } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShuffle,faVolleyball,faBars, faHome, faLayerGroup, faUsers, faUser, faGamepad, faCalendarPlus, faPlusSquare, faTrophy, faRankingStar, faMedal, faComments, faCopy } from '@fortawesome/free-solid-svg-icons';
import ReactGA from "react-ga4";
import { MainRoutes } from './routes/mainRoutes';
import axios from 'axios';
import config from "./config/default.json";
import { useTournament } from './components/TournamentContext'; 
import { TournamentProvider } from './components/TournamentContext';
import 'react-toastify/dist/ReactToastify.css';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon, WorkplaceShareButton, WorkplaceIcon, XIcon } from 'react-share'; 
import { toast, ToastContainer } from 'react-toastify';
import useScrollRestoration from './useScrollRestoration';
import {useRouteType} from './routes/routesUtil';

const base_url = config.base_url;



//Initialize GA4 --> G-CGMYJ4SECK
ReactGA.initialize("G-CGMYJ4SECK");

function Header() {

  useScrollRestoration(); 


  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const {tournament, setTournamentID, setLinkindex } = useTournament();
  const location = useLocation();
  const [currentUrl, setCurrentUrl] = useState(window.location.href);
  const { LinkParam, isCurrentPage,isHomepage, isAdminPage,isTournamentHomePage, isTournamentSubPage,isAuthPage, isContactpage, isAdminHomepage } = useRouteType();
 

  const handleMenuStateChange = (state) => {
    setIsMenuOpen(state.isOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    
     if (LinkParam && LinkParam !== tournament?.linkindex) {
    //setTournamentID(LinkParam); ID not good for SEO so moved back to linkindex
    setLinkindex(LinkParam);
  }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as per your needs
    };

    handleResize(); // Set initial value
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [LinkParam]);


  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, [location]);


  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      toast.success('Copied to clipboard');
      handleShare('CopyToClipboard');
    }).catch(err => {
      console.error('Failed to copy: ', err);
      toast.error('Failed to copy');
    });
  };


  const handleShare = async (platform) => {
    try {
      await axios.post(base_url + '/api/share', {
        url: currentUrl,
        platform: platform
      });

    } catch (error) {
      console.error('Error updating share count:', error);
    }
  };


  return (
    <div>
       {isMobile && (isTournamentHomePage || isTournamentSubPage )  ? (
        <footer className="mobile-menu">
          {/* <Link to="/teams" onClick={closeMenu} className={isCurrentPage('/teams') ? 'selected-menu-item' : ''}>
            <FontAwesomeIcon icon={faUsers} />
            &nbsp; Teams
          </Link> */}
          <Link to={`/${tournament?.linkindex}/schedules`} onClick={closeMenu} className={isCurrentPage(`/${tournament?.linkindex}/schedules`) ? 'selected-menu-item' : ''}>
            <FontAwesomeIcon icon={faCalendarPlus} />
            &nbsp; Schedules
          </Link>
          <Link to={`/${tournament?.linkindex}/scores`} onClick={closeMenu} className={isCurrentPage(`/${tournament?.linkindex}/scores`) ? 'selected-menu-item' : ''}>
            <FontAwesomeIcon icon={faTrophy} />
            &nbsp; Score
          </Link>
          <Link to={`/${tournament?.linkindex}/standings`} onClick={closeMenu} className={isCurrentPage(`/${tournament?.linkindex}/standings`) ? 'selected-menu-item' : ''}>
            <FontAwesomeIcon icon={faRankingStar} />
            &nbsp; Standings
          </Link>
          <Link to={`/${tournament?.linkindex}/wildcard`} onClick={closeMenu} className={isCurrentPage(`/${tournament?.linkindex}/wildcard`) ? 'selected-menu-item' : ''}>
            <FontAwesomeIcon icon={faShuffle} />
            &nbsp; WildCard
          </Link>
          <Link to={`/${tournament?.linkindex}/playoff`} onClick={closeMenu} className={isCurrentPage(`/${tournament?.linkindex}/playoff`) ? 'selected-menu-item' : ''}>
            <FontAwesomeIcon icon={faMedal} />
            &nbsp; Playoff
          </Link>
        </footer>
      ) : isTournamentHomePage || isTournamentSubPage ?  (
        <header className="desktop-header">
        <button className="menu-button" onClick={() => setIsMenuOpen(true)}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <Menu
          isOpen={isMenuOpen}
          onStateChange={handleMenuStateChange}
          left
          disableAutoFocus
          width="200px"
          customBurgerIcon={false}
          customCrossIcon={false}
          itemListClassName="menu-links"
          burgerButtonClassName="burger-button"
        >
          <Link to={`/${tournament?.linkindex}/`} 
          className={isCurrentPage(`/${tournament?.linkindex}/`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faHome} />
            &nbsp; Home
          </Link>
          <Link to={`/${tournament?.linkindex}/teams`}
          className={isCurrentPage(`/${tournament?.linkindex}/teams`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faUsers} />
            &nbsp; Teams
          </Link>
          <Link to={`/${tournament?.linkindex}/schedules`} 
          className={isCurrentPage(`/${tournament?.linkindex}/schedules`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faCalendarPlus} />
            &nbsp; Schedules
          </Link>
          <Link to={`/${tournament?.linkindex}/scores`} 
          className={isCurrentPage(`/${tournament?.linkindex}/scores`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faTrophy} />
            &nbsp; Score
          </Link>
          <Link to={`/${tournament?.linkindex}/standings`} 
          className={isCurrentPage(`/${tournament?.linkindex}/standings`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faRankingStar} />
            &nbsp; Standings
          </Link>
          <Link to={`/${tournament?.linkindex}/wildcard`} 
          className={isCurrentPage(`/${tournament?.linkindex}/wildcard`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faShuffle} />
            &nbsp; WildCard
          </Link>
          <Link to={`/${tournament?.linkindex}/playoff`} 
          className={isCurrentPage(`/${tournament?.linkindex}/playoff`) ? 'selected-menu-item' : ''} 
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faMedal} />
            &nbsp; Playoff
          </Link>
          <Link to={`/${tournament?.linkindex}/feedback`} 
          className={isCurrentPage(`/${tournament?.linkindex}/feedback`) ? 'selected-menu-item' : ''}
          onClick={closeMenu}>
            <FontAwesomeIcon icon={faComments} />
            &nbsp; Feedback
          </Link>
        </Menu>
        </header>
      ): null}

    <header className="app-header">
   
  <div className="header-div"> 

     <div className="header-container">
    <div className="spacer" />

    <h1 className="rainbow-text center-title">
      <a href="/">
        <FontAwesomeIcon icon={faVolleyball} />
        &nbsp; VolleyTally &nbsp;
        <FontAwesomeIcon icon={faVolleyball} />
      </a>
    </h1>

    <div className="user-icon">
      <a href="/auth/profile">
        <FontAwesomeIcon icon={faUser} size="lg" />
      </a>
    </div>
  </div>
   
  {isHomepage || isAuthPage ? (
   null
) : (  
 
    <div className="subtitle-container">
      <h2 className="subtitle rainbow-text">
        {tournament?.acronym} 
      </h2>
    </div>
  
    )}

        
{isHomepage?null:isTournamentHomePage || isContactpage? (<Link to={`/`} className="header-button">
            <FontAwesomeIcon icon={faHome} /> &nbsp; Home
          </Link>):isAdminPage && !isAuthPage?( isAdminHomepage ? <Link to={`/auth/profile`} className="header-button">
            <FontAwesomeIcon icon={faUser} /> &nbsp; Profile
          </Link> : (<Link to={`/admin/${tournament?.linkindex}/admin`} className="header-button">
            <FontAwesomeIcon icon={faHome} /> &nbsp; Admin Home
          </Link>)):isTournamentSubPage?(<Link to={`/${tournament?.linkindex}`} className="header-button">
            <FontAwesomeIcon icon={faHome} /> &nbsp; Home
          </Link>):null}

     
    </div>
    </header>


    <main className="app-main">
        <MainRoutes />
       
        </main>
       
        <footer  className="app-footer">
         
         {isTournamentHomePage || isTournamentSubPage || isHomepage ? (   <div>         
      <br/>   
      Share this page 
      <br/>
                   
        <TwitterShareButton
                url={`${currentUrl}`}
                title={`Checkout ${tournament?.acronym} Tournament on VolleyTally`}
                hashtag={"volleytally"}
                onClick={() => handleShare('Twitter')}
              >
                <XIcon size={40} round  />
              </TwitterShareButton>
              &nbsp;
              <FacebookShareButton
                url={`${currentUrl}`}
                title={`Checkout ${tournament?.acronym} Tournament on VolleyTally`}
                hashtag={["volleyball", "volleytally"]}
                onClick={() => handleShare('Facebook')}
              >
                <FacebookIcon size={40} round />
              </FacebookShareButton>
              &nbsp;
              <WhatsappShareButton

                url={`${currentUrl}`}
                title={`Checkout ${tournament?.acronym} Tournament on VolleyTally`}
                hashtag={["volleyball", "volleytally"]}
                onClick={() => handleShare('Whatsapp')}
              >
                <WhatsappIcon size={40} round />
              </WhatsappShareButton>
              &nbsp;&nbsp;


              <FontAwesomeIcon icon={faCopy} size="3x" onClick={copyToClipboard} />

              <br/>
              <br/>
               Request hosting your tournament
          <h2 className='home-button'>
          <Link to="./contact" >
            <FontAwesomeIcon icon={faComments} />
            &nbsp; Contact From
          </Link>  
          </h2></div>):(<div></div>) }
         <br/>
           <p> © OpenFirst Tech 2023. All rights reserved. Developed by <a href="https://mjzhub.com/" target="_blank"> Maulik Zalavadia </a> 
                with help of <a href="https://openai.com/blog/chatgpt" target="_blank">ChatGPT</a>.  
                <a href = "https://www.linkedin.com/in/mjzhub/" target="_blank"> Reach out </a> for collaboration. &#10084; </p>
        
              
        </footer>
        
    </div>
    
  );
}



const App = () => {


  return (
    <TournamentProvider >
    <Router>
      <div className="app-container">
     
      <Header/>
      
       
      </div>
    </Router>
    </TournamentProvider>

  );
};

export default App;
